import { Link } from "react-router-dom";
import { COLORS } from "../hooks/useAudioRecorder";
import { TRADES } from "../data/trades";

/**
 * Cross-links to the trade landing pages (internal links help indexing).
 * Shown on Home (via WhatIsHandInvoice) and at the bottom of each trade
 * page, where `current` drops the page's own link. Each link is a 44px-tall
 * tap target (gloves non-negotiable) even though the text is small.
 */
export default function TradeLinks({ current }) {
  return (
    <nav
      aria-label="HandInvoice by trade"
      style={{
        marginTop: 28,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        columnGap: 4,
        fontFamily: "'JetBrains Mono', ui-monospace, monospace",
        fontSize: 11,
        letterSpacing: "0.06em",
        color: COLORS.faint,
      }}
    >
      <span style={{ marginRight: 4 }}>{current ? "// also for" : "// built for"}</span>
      {TRADES.filter((t) => t.slug !== current).map((t) => (
        <Link
          key={t.slug}
          to={"/" + t.slug}
          style={{
            display: "inline-flex",
            alignItems: "center",
            minHeight: 44,
            padding: "0 8px",
            color: "#a8a29a",
            textDecoration: "none",
          }}
        >
          {t.name}
        </Link>
      ))}
    </nav>
  );
}
